import { useState } from "react";
import { DialogContent, IconButton, Tooltip } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { useTranslation } from "react-i18next";
import DialogComponent from "../../Dialog/Dialog";
import HelpContent from "./HelpContent";
import { PaymentsHelpContentKey } from "../../../constants";

/** Icon button that opens the contextual help for a payments screen. */
export default function HelpButton({
  linkName,
  title
}: {
  linkName: PaymentsHelpContentKey;
  title?: string;
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const label = title ?? t("paymentConfigurations.help");

  return (
    <>
      <Tooltip title={label}>
        <IconButton onClick={() => setOpen(true)} aria-label={label}>
          <HelpOutlineIcon />
        </IconButton>
      </Tooltip>
      <DialogComponent open={open} handleModal={setOpen} headerTxt={label}>
        <DialogContent>
          {/* Only fetch the document once the user actually asks for it. */}
          {open && <HelpContent linkName={linkName} explainWhenMissing />}
        </DialogContent>
      </DialogComponent>
    </>
  );
}
